import { Box, List, ListItem } from "@mui/material";
import React from "react";
import styles from "../../../styles/components/video.module.scss";
import styles1 from "../../../styles/components/copyrightOwnerships.module.scss";
import { emptyHandle, hasYes } from "../../../lib/functions/utils.lib";

const CopyrightOwnershipsTwo = ({ data }) => {
    return (
        <>
            {data && (
                <Box
                    className={`VideocommonBox VideocommonBoxsubmit ${hasYes(data.people_appearing) ||
                        hasYes(data.submit_place) ||
                        hasYes(data.did_anyone_reach) ||
                        hasYes(data.aggrement_with_another_company)
                        ? "VideocommonBoxError"
                        : ""
                        }`}
                >
                    <Box className={`${styles.ownerDetails} ${styles.ownerDetailsError}`}>
                        <Box
                            className={`${styles.commonHeading} ${styles1.copyRightcommonHeading}`}
                        >
                            <h4><label className={styles.copyLabelBg}>Copyrights Ownership</label></h4>
                        </Box>

                        <Box
                            className={`${styles1.copyRightTxt} ${styles1.copyRightTxtError} ${styles1.copyRightOwnerTwo}`}
                        >
                            <List>
                                <ListItem>
                                    <Box className={styles1.copyRighttxtBox}>
                                        <h4>The person who filmed this video is</h4>
                                        <h5>{data?.person_who_filmed}</h5>
                                    </Box>
                                </ListItem>
                                <ListItem>
                                    <Box
                                        className={`${styles1.copyRighttxtBox} ${hasYes(data.people_appearing)
                                            ? styles1.copyRighttxtBoxOrange
                                            : ""
                                            }`}
                                    >
                                        <h4>Are There People Appearing In the Video?</h4>
                                        <h5>{data?.people_appearing}</h5>
                                    </Box>

                                    <Box className={styles1.copyRightAnswer}>
                                        <Box className={styles1.copyRightAnswerOrange}>
                                            <h4>Who are they?</h4>
                                            <h5>my friends</h5>
                                        </Box>
                                    </Box>

                                    {/* {hasYes(data.people_appearing) && (
                    <Box
                      className={`${styles1.copyRighttxtBox} ${styles1.copyRighttxtBoxOrange}`}
                    >
                      <h4>Who are they?</h4>
                      {hasYes(data.people_appearing) && (
                        <>
                          {data.people_appearing_list ? data.people_appearing_list?.map((p, i) => (
                            <h5 key={i}>{p}</h5>
                          )) : <h5>N/A</h5>}
                        </>
                      )}
                    </Box>
                                        )} */}
                                </ListItem>
                                <ListItem>
                                    <Box
                                        className={`${styles1.copyRighttxtBox} ${hasYes(data.submit_place)
                                            ? styles1.copyRighttxtBoxRed
                                            : ""
                                            }`}
                                    >
                                        <h4>
                                            Did You Send/Submit/Upload This Video To A Website And/Or
                                            Social Media Account?{" "}
                                        </h4>
                                        <h5>{data.submit_place}</h5>
                                    </Box>

                                    <Box className={styles1.copyRightAnswer}>
                                        <Box className={`${styles1.copyRightAnswerOrange} ${styles1.copyRightAnswerRed}`}>
                                            <h4>Where Did You Submit It?</h4>
                                            <h5>Our Instagram, Facebook and youTube</h5>
                                        </Box>
                                    </Box>
                                    {/* {hasYes(data.submit_place) && (
                                        <Box
                                            className={`${styles1.copyRighttxtBox} ${styles1.copyRighttxtBoxRed}`}
                                        >
                                            <h4>Where Did You Submit It?</h4>
                                            <h5>
                                                {emptyHandle(data.submit_other_website)}
                                            </h5>
                                        </Box>
                                    )} */}
                                </ListItem>
                                <ListItem>
                                    <Box
                                        className={`${styles1.copyRighttxtBox} ${hasYes(data.did_anyone_reach)
                                            ? styles1.copyRighttxtBoxOrange
                                            : ""
                                            }`}
                                    >
                                        <h4>Did Anyone Reach You About Using This Video?</h4>
                                        <h5>
                                            {emptyHandle(data.did_anyone_reach)}
                                        </h5>
                                    </Box>

                                    <Box className={styles1.copyRightAnswer}>
                                        <Box className={`${styles1.copyRightAnswerOrange}`}>
                                            <h4>Where Did You Submit It?</h4>
                                            <h5>Our Instagram, Facebook and youTube</h5>
                                        </Box>
                                    </Box>
                                    {/* {hasYes(
                                        data.did_anyone_reach && (
                                            <Box
                                                className={`${styles1.copyRighttxtBox} ${styles1.copyRighttxtBoxOrange}`}
                                            >
                                                <h4>
                                                    Please share the name of the company/page with us
                                                </h4>
                                                <h5>Viralhog, jukin</h5>
                                            </Box>
                                        )
                                    )} */}
                                </ListItem>
                                <ListItem>
                                    <Box
                                        className={`${styles1.copyRighttxtBox} ${hasYes(data.aggrement_with_another_company)
                                            ? styles1.copyRighttxtBoxRed
                                            : ""
                                            }`}
                                    >
                                        <h4>
                                            Did You Sign A Licensing Agreement For This Video With
                                            Another Company/Page?
                                        </h4>
                                        <h5>
                                            {emptyHandle(data.aggrement_with_another_company)}
                                        </h5>
                                    </Box>

                                    <Box className={styles1.copyRightAnswer}>
                                        <Box className={`${styles1.copyRightAnswerOrange}`}>
                                            <h4>Where Did You Submit It?</h4>
                                            <h5>Our Instagram, Facebook and youTube</h5>
                                        </Box>
                                    </Box>
                                    {/* {hasYes(data.aggrement_with_another_company) && (
                                        <Box
                                            className={`${styles1.copyRighttxtBox} ${styles1.copyRighttxtBoxRed}`}
                                        >
                                            <h4>Name of the company/page?</h4>
                                            <h5>
                                                {emptyHandle(data.release_company)}
                                            </h5>
                                        </Box>
                                    )} */}
                                </ListItem>
                            </List>
                        </Box>
                    </Box>
                </Box>
            )}
        </>
    );
};

export default CopyrightOwnershipsTwo;


